import { Option, Value } from 'baseui/select';
import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ActionType } from 'components/elements/table/type';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useGroupDetailTableList } from './table-column';
import {
  CruisePurchaseDetailsItemFormType,
  CruisePurchaseFormType,
} from '../../form-type';

interface Props {
  parentIndex: number;
  cruiseRoomList: Option[];
}

export default function CruiseGuestDetailGroupedTable(props: Props) {
  const { editable } = useFormState();
  const { control, setValue, getValues, clearErrors } =
    useFormContext<CruisePurchaseFormType>();

  const name =
    `cruisePurchases.${props.parentIndex}.cruisePurchaseDetails` as const;

  const detailsValue = useWatch({
    control,
    name,
  });

  const columns = useGroupDetailTableList(props.cruiseRoomList);

  const dispatch = React.useCallback(
    (action) => {
      const details = getValues(name);
      const { customId, id, guestId, guestName, ...rest } = details[0];
      const columnId =
        action.columnId as keyof CruisePurchaseDetailsItemFormType;
      const extra = action.extra as Value;
      const type = action.type as ActionType;
      const value = action.value;

      const otherVal: () => Partial<CruisePurchaseDetailsItemFormType> = () => {
        if (columnId === 'cruiseRoomId') {
          return {
            cruiseRoomName: extra?.[0]?.label as string,
          };
        }
        return {};
      };

      if (type === 'update_cell') {
        const rowValue = {
          ...rest,
          [columnId]: value,
          ...otherVal(),
        };

        const _details = details.map((detail) => {
          return {
            ...detail,
            ...rowValue,
          };
        });

        setValue(name, _details);
        clearErrors(name);
      }
    },
    [clearErrors, getValues, name, setValue],
  );

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={[detailsValue[0]]}
        dispatch={dispatch}
        disabled={!editable}
        noAddRemoveRow
        name={name}
        uniqueRowKey="customId"
      />
      <SeparatorVertical $margin={12} />
    </div>
  );
}
